import { TaxExemptionBasis } from '@dreryk/egabinet-invoice-frontend-api';

import { BindingCreator, useTranslate } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { invoiceSharedComponentsTranslationKeys } from '../translations';

const TAX_EXEMPTION_BASIS_FIELD_NAME = 'taxExemptionBasis';
const ITEMS: TaxExemptionBasis[] = [
   'EXEMPTION_18',
   'EXEMPTION_18A',
   'EXEMPTION_19',
   'EXEMPTION_19A',
   'EXEMPTION_20',
   'NO_EXEMPTION',
];

export type TaxExemptionBasisFormBeanPart = {
   [TAX_EXEMPTION_BASIS_FIELD_NAME]: TaxExemptionBasis;
};

type TaxExemptionBasisFieldProps = {
   readonly register: BindingCreator<TaxExemptionBasisFormBeanPart, typeof TAX_EXEMPTION_BASIS_FIELD_NAME>;
};

export const TaxExemptionBasisField = (props: TaxExemptionBasisFieldProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <Select<TaxExemptionBasis>
         controller={props.register(TAX_EXEMPTION_BASIS_FIELD_NAME)}
         testId={TAX_EXEMPTION_BASIS_FIELD_NAME}
         label={invoiceSharedComponentsTranslationKeys.taxExemptionBasis.label}
         triggerLabelExtractor={(item) => translate(invoiceSharedComponentsTranslationKeys.taxExemptionBasis.map[item])}
      >
         <Select.List items={ITEMS}>
            {(item: TaxExemptionBasis) => (
               <Select.Item<TaxExemptionBasis>
                  item={item}
                  testId={item}
                  label={invoiceSharedComponentsTranslationKeys.taxExemptionBasis.map[item]}
               />
            )}
         </Select.List>
      </Select>
   );
};
